/**
 * Below are the colors that are used in the app. The colors are defined in the light and dark mode.
 * There are many other ways to style your app. For example, [Nativewind](https://www.nativewind.dev/), [Tamagui](https://tamagui.dev/), [unistyles](https://reactnativeunistyles.vercel.app), etc.
 */

export const Colors = {
  white: "#fff",
  primary: "#0F9129",
  text: "#11181C",
  background: "#F8F9FA",
  tint: "#0a7ea4",
  icon: "#687076",
  tabIconDefault: "#687076",
  tabIconSelected: "#0a7ea4",
  border: "#E1EFE4",
  primaryButton: "#0F9129",
  bgSecondary: "rgba(86, 93, 255, 0.05)",
  hideText: "#161D1450",
  error: "#FF0000",
  lightIcon: "#919191",
  lightGrey2: "#F3F3F3",
};

// OfferCard specific colors
export const OfferCardColors = {
  card: {
    background: "#fff",
    border: "#F3F3F3",
    shadow: "#000",
  },
  tag: {
    background: "#D1FAE5",
    text: "#161D14",
  },
  text: {
    primary: "#000",
    secondary: "#6B7280",
  },
  button: {
    hide: "#F4F5F6",
    primary: "#4F46E5",
  },
  image: {
    background: "#F7F8FA",
  },
};
